<div class="delete-dialog">
  <!-- Icon -->
  <div class="delete-dialog__body">
    <div class="delete-dialog__icon-ring">
      <mat-icon>warning</mat-icon>
    </div>

    <h3>Delete Contact</h3>
    <p>
      Are you sure you want to delete
      <strong>{{ contactName }}</strong>?
      This action cannot be undone.
    </p>
  </div>

  <!-- Actions -->
  <div class="delete-dialog__footer">
    <button class="btn btn--secondary" (click)="cancel()" [disabled]="loading">
      Cancel
    </button>
    <button class="btn btn--danger" (click)="confirm()" [disabled]="loading">
      <mat-icon>delete</mat-icon>
      {{ loading ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</div>
